/** Yjs binary protocol message types */
export const MSG_SYNC = 0;
export const MSG_AWARENESS = 1;
export const MSG_PRESENCE = 2;
export const MSG_EDITORS = 3;
export const MSG_SYNC_COMPLETE = 4;

/** Yjs sync sub-message types */
export const MSG_SYNC_STEP1 = 0;
export const MSG_SYNC_STEP2 = 1;
export const MSG_SYNC_UPDATE = 2;

/** Canvas API path prefixes */
export const API_CANVAS = "/api/v1/canvas";
export const API_CANVAS_SESSION = "/api/v1/canvas-session";
export const API_CANVAS_SHARE = "/api/v1/canvas-share";
export const API_CANVAS_TOKEN = "/api/v1/auth/canvas-token";

/** Canvas Relay WebSocket path prefixes */
export const WS_USER = "/ws";
export const WS_AGENT = "/ws/agent";
export const WS_SHARE = "/ws/share";
